export function safeJsonParse<TResult>(
  json: string | null | undefined,
): TResult | undefined {
  if (!json) {
    return undefined;
  }

  try {
    return JSON.parse(json) as TResult;
  } catch {
    return undefined;
  }
}
